<template>
  <div class="landing_banner_section">
    <div
      ref="banner_header"
      class="landing_slider_header ls_header"
      style="height: 420px"
    >
      <div v-for="(banner, index) in banners" :key="index">
        <banner-default v-if="parseInt(banner.type) === 2" :banner="banner" />
        <banner-social v-if="parseInt(banner.type) === 3" :banner="banner" />
      </div>
    </div>
    <div class="landing-banner-slick-arrow">
      <div ref="banner_header_prev" class="class-to-style left"><span class="fa fa-angle-left arrow-left" /></div>
      <div ref="banner_header_next" class="class-to-style right"><span class="fa fa-angle-right arrow-right" /></div>
    </div>
  </div>
</template>

<script>
import { component } from '../../../../mixins/component';
import BannerDefault from './BannerDefault';
import BannerSocial from './BannerSocial';
import 'slick-carousel/slick/slick.min';
import jQuery from 'jquery';
import Vue from 'vue';

export default {
  components: { BannerSocial, BannerDefault },
  mixins: [component],
  props: {
    banners: {
      type: Array,
      default() {
        return [];
      },
    },
    timeChangeBanner: {
      type: Number,
      default: 3000,
    },
    tournamentInfo: {
      type: Object,
      default() {
        return {
          prize: 0,
          total_streamers: 0,
          total_users: 0,
        };
      },
    },
  },
  watch: {
    banners: function(newVal, oldVal) {
      Vue.nextTick(() => {
        this.initSlick();
      });
    },
  },
  methods: {
    initSlick() {
      jQuery(this.$refs.banner_header).slick({
        autoplay: true,
        autoplaySpeed: this.timeChangeBanner,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: false,
        dots: true,
        initialSlide: 0,
        prevArrow: jQuery(this.$refs.banner_header_prev),
        nextArrow: jQuery(this.$refs.banner_header_next),
      });
    },
  },
};
</script>
